import i18n from "../../../../constants/i18n";
import { DEVELOPER_ALARMS_HEADERS } from "../../../../constants/table-custom-headers/Developers";
import getDevelopmentAlarmsStore from "../../../../stores/developer-store/development_alarms-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const TurnOffAlarmsData = withLiteObserverAndTheme(() => {
  const developmentAlarms =
    getDevelopmentAlarmsStore().developmentAlarmData.get();

  return (
    <Et3Table
      columns={DEVELOPER_ALARMS_HEADERS}
      rows={developmentAlarms}
      title={i18n.get("ALARMS")}
      shouldBeFlagged={false}
      titleKey={"ALARMS"}
    />
  );
});
export default TurnOffAlarmsData;
